export default "__VITE_ASSET__DM$QJbSi__"